import React, { CSSProperties, FC, memo } from 'react'
import block from 'bem-cn'

import { CellType, ColumnAlignVariants, ColumnFixedVariants } from '../types'

import './Cell.scss'

const b = block('table-cell')

export type CellProps = {
  type?: CellType
  className?: string
  fixed?: ColumnFixedVariants
  paddingLeft?: number
  align?: ColumnAlignVariants
  left?: number
  right?: number
  withBorder?: boolean
  withShadow?: boolean
  isFirst?: boolean
  isLast?: boolean
  isHead?: boolean
}

export const Cell: FC<CellProps> = memo(
  ({
    withBorder,
    withShadow,
    right,
    align,
    left,
    type = CellType.TEXT,
    children,
    className,
    paddingLeft,
    fixed,
    isFirst,
    isLast,
    isHead,
  }) => {
    const style: CSSProperties = { paddingLeft, left, right }
    const classNames = b('wrapper').mix(
      className,
      type,
      fixed,
      withBorder && 'withBorder',
      withShadow && 'withShadow',
      align,
      isLast && 'isLast',
      isFirst && 'isFirst',
    )

    if (isHead) {
      return (
        <th className={classNames} style={style}>
          {children}
        </th>
      )
    }

    return (
      <td className={classNames} style={style}>
        {children}
      </td>
    )
  },
)

Cell.displayName = 'Cell'
